module.exports = __webpack_public_path__ + "static/assets/c52d2bb406ad7f8702d0d95d2996b6a5.gif";